import React from 'react';
import styles from './styles';
import { FormattedMessage } from 'react-intl';

export const RBHText = (props: any) => {
  let style = props.style;
  if (props.disabled) {
    style = { ...props.style, ...styles.disabled };
  }
  return (
    <div {...props} style={{ ...styles.textDefault, ...props.style, ...style }}>
      {props.text ? <FormattedMessage id={props.text} values={props.values} /> : null}
      {props.children}
      <br />
    </div>
  );
};

export default RBHText;
